<template>
    <div class="productPanel">
        <div class="left_panel_class">
            <div class="title-1">{{$t('产品分类')}}</div>
            <div class="line"></div>
            <div class="left_panel_class_info" @click="turnClass(1)">{{$t('一次性防护服')}}</div>
            <div class="left_panel_class_info" @click="turnClass(2)">{{$t('实验服')}}</div>                   
            <div class="left_panel_class_info" @click="turnPro(3,13)">{{$t('隔离衣')}}</div>                   
            <div class="left_panel_class_info"  @click="turnClass(4)">{{$t('一次性防护口罩')}}</div>                   
            <div class="left_panel_class_info" @click="turnClass(5)">{{$t('透气膜头套')}}</div>                   
            <div class="left_panel_class_info" @click="turnPro(6,18)">{{$t('胡须套')}}</div>                   
            <div class="left_panel_class_info" @click="turnPro(7,19)">{{$t('条帽')}}</div>                   
            <div class="left_panel_class_info" @click="turnClass(8)">{{$t('袖套')}}</div>                   
            <div class="left_panel_class_info" @click="turnClass(9)">{{$t('靴套')}}</div>                   
            <div class="left_panel_class_info" @click="turnClass(10)">{{$t('鞋套')}}</div>                   
            <div class="left_panel_class_info" @click="turnPro(11,29)">{{$t('PE塑料手套')}}</div>                                                          
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        turnClass(id){
            this.$router.push({
                path:"/productClass_info_class",//这个path就是你在router/index.js里边配置的路径
                query:{
                    classId:id,
                }
            })
            // this.$router.go(0)
        },
        turnPro(cid,pid){
            this.$router.push({
                path:"/productClass_info",//这个path就是你在router/index.js里边配置的路径
                query:{
                    classId:cid,
                    productId:pid
                }
            })

            // 
        }
    }
}
</script>
<style lang="less" scoped>
.productPanel{
    .left_panel_class{
        background-color: #F5F5F5;
        font-size: 1vw;
        min-height: 10vw;
        width: 100%;
        padding-top: 1px;
        cursor: pointer;
    }
    .left_panel_class_info{
        color: #444444;
        font-size: 1vw;
        line-height: 2.5vw;
        width: fit-content;
        margin-left: 10%;
        font-family: 'pf';
        font-weight: lighter;
    }
    .line{
        width: 88%;
        height: 1px;
        background-color: #444444;
        margin: 0 auto;
    }
    .title-1{
        color: #444444;
        font-family: 'YHBD';
        font-weight: bold;
        font-size: 1.3vw;
        letter-spacing: 0.1vw;
        width: fit-content;
        // line-height: 4vw;
        height: fit-content;
        margin-top: 1vw;
        margin-bottom: 1vw;
        margin-left: 10%;
    }
}
</style>
<i18n>
{
  "en": {
       "一次性防护服":"Disposable Coverall",
       "实验服":"Disposable Lab Coat",
       "隔离衣":"Disposable Isolation Gown",
       "一次性防护口罩":"Disposable Face Mask",
       "透气膜头套":"Microporous Hood",
       "胡须套":"Beard Cover",
       "条帽":"Bouffant Cap",    
       "袖套":"Microporous Sleeve Cover",       
       "靴套":"Disposable Boot Cover",       
       "鞋套":"Shoe Cover",
       "PE塑料手套":"Plastic Gloves"
  },
  "zh": {
       "一次性防护服":"一次性防护服",
       "实验服":"实验服",
       "隔离衣":"隔离衣",
       "一次性防护口罩":"一次性防护口罩",
       "透气膜头套":"透气膜头套",
       "胡须套":"胡须套",
       "条帽":"条帽",    
       "袖套":"袖套",       
       "靴套":"靴套",       
       "鞋套":"鞋套",
       "PE塑料手套":"PE塑料手套"
    }
}
</i18n>
